import {
  BoostNotificationQuery,
  BoostNotificationQueryDocument,
} from './BoostNotificationQuery.generated';
import addBoostNotificationToQueue from '../../../helpers/addBoostNotificationToQueue';
import toJson from '@/shared/utils/toJson';

const getBoostNotifications: WorkerQuery = async (args) => {
  const { context, fetch, addToQueue } = args;
  if (!context.featureFlags.get('isCasinoBoostsEnabled')) {
    return;
  }
  const response = await fetch(BoostNotificationQueryDocument, {});
  const { data } = await toJson<BoostNotificationQuery>(response);
  data?.casinoBoostsPublic?.boostTimers?.edges?.forEach(({ node }) =>
    addBoostNotificationToQueue(addToQueue, node),
  );
};

export default getBoostNotifications;
